import { createBrowserClient as createSupabaseBrowserClient } from "@supabase/ssr"

/**
 * Create a Supabase browser client for use in Client Components
 * Uses environment variables from the browser
 *
 * This is a separate entry point from "client.ts" to avoid importing
 * server-only modules (next/headers) in client components.
 */
export function createBrowserClient() {
  return createSupabaseBrowserClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!
  )
}
